import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import BusinessIcon from '@material-ui/icons/Business';
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import Button from "@material-ui/core/Button";
import Tooltip from '@material-ui/core/Tooltip';

import Badge from "@material-ui/core/Badge";
import MailIcon from "@material-ui/icons/Mail";
import BlockIcon from '@material-ui/icons/Block';
import InfoIcon from '@material-ui/icons/Info';

import imgUrl from "../../assets/images/imageUrl";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "36ch",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
}));

function SurveyList(props) {
  const { t } = props;
  const classes = useStyles();
  const { templateID } = props;
  let colorStyles = templateID == 2 ? { color: props.componentbgcolor } : {};
  let history = useHistory();
  const [open, setOpen] = React.useState(false);

  var imurl = props.serviceObj.iconUrl ? getHttpsUrl(props.serviceObj.iconUrl) : imgUrl.qaulity;
  
  const [imgurl, setUrl] = React.useState(imurl);

  function getHttpsUrl(iconurl) {
    var spliurtl = iconurl.split("://")
    let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
    return myUrl;
  }

  function handleClick() {
    console.log('handleClick>>', props)
    history.push({
      pathname: "/layout/SurveyForm",
      state: props.serviceObj,
    });
  }

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };


  return (
    <Grid
      key={props.serviceObj.id}
      container
      spacing={0}
      className="gridcontainer chatuserlistdiv borderbottomgrey"
    >
      <Grid item xs={2} className="zero">
        <p className="zero color-green text-center forumicon">
         <img src={imgurl}  className="serviceImg"/>
        </p>
      </Grid>
      <Grid item xs={7} className="zero">
        <div className="zero  chatusername" style={colorStyles}>
          <span className="servicename" onClick={handleClick}>{props.serviceObj.name}</span>
          {/* <span className="servicename">
            <Tooltip open={open} onClose={handleTooltipClose} title={props.serviceObj.description} arrow placement="top">
              <InfoIcon onClick={handleTooltipOpen} />
            </Tooltip>
          </span> */}

        </div>
      </Grid>
    </Grid>
  );
}



const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};



const transServicesList = withTranslation()(SurveyList);
export default connect(mapStateToProps, {})(transServicesList);
